import { Control } from "react-hook-form";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import Box from "@mui/material/Box";

import SelectFormField from "components/select-form-field";
import { COMMUNICATION_METHOD_TYPES } from "constants/patients";

import { PatientFormValues } from "../patient-form.component";

type CommunicationMethodProps = {
  control: Control<PatientFormValues, object>;
};

export default function CommunicationMethodField({
  control
}: CommunicationMethodProps) {
  return (
    <Box display="flex" justifyContent="space-between" width="100%">
      <AccountCircleOutlinedIcon sx={{ mt: "30px", mr: 1.5 }} color="action" />
      <SelectFormField
        name="preferred_communication_method"
        label="Preferred Communication method"
        control={control}
        options={COMMUNICATION_METHOD_TYPES.getOptions()}
        required
      />
    </Box>
  );
}
